import React from "react";
import styles from "./reader.module.css";
import MediaRenderer from "./MediaRenderer";

export default function LessonContent({ book, sectionTitle, lesson }) {
  return (
    <>
      <div className={styles.breadcrumb}>
        {book.title} &nbsp;›&nbsp; {sectionTitle} &nbsp;›&nbsp; {lesson.label || lesson.title}
      </div>
      <h1 className={styles.title}>{lesson.label || lesson.title}</h1>

      <MediaRenderer type={lesson.type} videoUrl={lesson.videoUrl} content={lesson.content} />

      {lesson.extra && <div className={styles.card} dangerouslySetInnerHTML={{ __html: lesson.extra }} />}
    </>
  );
}
